// TODO: ADICIONAR PAGINAÇÃO
/* eslint-disable no-unused-vars */
import { useCollectionDataOnce } from 'react-firebase-hooks/firestore';
import { products, categoryProducts, product, defaultCollOptions } from '../utils/collections';
import { getRefMany, getRefOne, onRefMany } from '../utils/firebase';
import { parseKeywords } from '../../utils/parseKeywords';

export const productsRef = ({ category, sortBy, sortOrder, limit, query } = {}) => {
  const isCategoryValid = category && category !== 'todas';
  let ref = isCategoryValid ? categoryProducts(category) : products;

  if (sortBy) ref = ref.orderBy(sortBy, sortOrder);
  if (limit) ref = ref.limit(limit);
  if (query) ref = ref.where('keywords', 'array-contains-any', parseKeywords(query));

  return ref.where('deleted', '==', false);
};

export const listProducts = (query = {}) => getRefMany(productsRef(query));
export const getProduct = (productID) => getRefOne(product(productID));

export const deleteProduct = (productID) => product(productID).update({ deleted: true });

export const sellerProductsRef = (sellerID) => productsRef().where('seller', '==', sellerID);
export const getProductsBySeller = (sellerID) => getRefMany(sellerProductsRef(sellerID));
export const onProductsBySeller = (sellerID, callback) =>
  onRefMany(sellerProductsRef(sellerID), callback);

export const parseData = (data) => {
  const newData = data;
  if (newData.name) newData.keywords = parseKeywords(newData.name);
  return newData;
};

export const updateProduct = (productID, data) => product(productID).update(parseData(data));

export const useGetProducts = (query = {}) =>
  useCollectionDataOnce(productsRef(query), defaultCollOptions);
